import Root from "./routes/Root";
import {ThemeProvider} from "@material-tailwind/react";

function App() {
  return (
      <ThemeProvider>
          <Root/>
      </ThemeProvider>
  );
}

export default App;
